import * as React from 'react';

import { ResourceDialogFooter } from 'src/components/resourceDialog/DialogFooter';
import { TEST_IDS } from 'src/constants/testIds';
import { useProjectResourceDialog } from 'src/containers/ProjectNewResourceDialogV2/context/useProjectResourceDialog';

export const ProjectNewResourceDialogFooter: React.VFC = () => {
  const { footerOptions } = useProjectResourceDialog();

  return (
    <ResourceDialogFooter
      backButtonTestId={TEST_IDS.projectResourceDialog.backButton}
      createAndMapButtonTestId={
        TEST_IDS.projectResourceDialog.createAndMapButton
      }
      createButtonTestId={TEST_IDS.projectResourceDialog.createButton}
      footerOptions={footerOptions}
      nextButtonTestId={TEST_IDS.projectResourceDialog.createButton}
    />
  );
};
